import React from "react";
import {Form, Select} from "antd";
import {observer} from "mobx-react-lite";
import {rolesModel} from "../../../../../../entities/roles";

// the user's roles: one or more, their rights add up (what each role gives — section «Роли»)
export const Selects = observer(({formItemLayout}) => (
  <Form.Item
    {...formItemLayout}
    label='Роли'
    name='roleIds'
    rules={[{required: true, type: 'array', min: 1, message: 'Выберите хотя бы одну роль'}]}
    extra='Можно выбрать несколько: права ролей складываются'
  >
    <Select
      mode='multiple'
      placeholder='Выберите роли пользователя'
      style={{width: '100%'}}
      optionFilterProp='label'
      options={rolesModel.roles.map((role) => ({value: role.id, label: role.title || role.name}))}
    />
  </Form.Item>
))
